import { LatLng, MapLocation } from "types/map";
import { hasLatLong } from "libraries/map";

/** Typical flight-path detour vs great-circle. */
export const FLIGHT_DETOUR_FACTOR = 1.09;

/** ADEME-style short-haul / domestic kg CO₂e per passenger-km. */
export const FLIGHT_KG_CO2_PER_KM = 0.246;

const EARTH_RADIUS_KM = 6371;

const toRadians = (degrees: number): number => (degrees * Math.PI) / 180;

export const toLatLng = (location: MapLocation): LatLng | null => {
  if (!hasLatLong(location)) {
    return null;
  }

  return { lat: location.latitude as number, lng: location.longitude as number };
};

export const greatCircleDistanceKm = (from: LatLng, to: LatLng): number => {
  const lat1 = toRadians(from.lat);
  const lat2 = toRadians(to.lat);
  const dLat = toRadians(to.lat - from.lat);
  const dLng = toRadians(to.lng - from.lng);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

  return 2 * EARTH_RADIUS_KM * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
};

export const flightDistanceKm = (from: LatLng, to: LatLng): number =>
  greatCircleDistanceKm(from, to) * FLIGHT_DETOUR_FACTOR;

export const flightEmissionKg = (from: LatLng, to: LatLng): number =>
  flightDistanceKm(from, to) * FLIGHT_KG_CO2_PER_KM;

export const flightDistanceMeters = (from: LatLng, to: LatLng): number =>
  flightDistanceKm(from, to) * 1000;
